import * as React from 'react';
import { ContentCreatorStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels/Panel';
import { IAOptionSelector } from '../../optionSelector/OptionSelector';
import { IADropDown } from '../../dropDown/DropDown';
import { IInstance } from '../../../interfaces/IInstance';
import InstanceService from '../../../services/InstanceService';
// import CategoryService from '../../../services/CategoryService';
import { ITreeViewItem } from '../../../interfaces/ITreeViewItem';
// import { IATreeview } from '../../treeview/Treeview';
import { IATextField } from '../../textField/TextField';

import ContentCreatorService from '../../../services/ContentCreatorService';
// import { ICategory } from '../../../interfaces/ICategory';
import { IContentCreator } from '../../../interfaces/IContentCreator';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAIconPicker } from '../../iconPicker/IconPicker';
import { ChoiceOptions, IAChoiceGroup } from '../../choiceGroup/ChoiceGroup';
import MessageTemplateService from '../../../services/MessageTemplateService';
import { IASkeleton } from '../../skeleton/Skeleton';
import EventTemplateService from '../../../services/EventTemplateService';

export interface IProps {
  contentCreatorStore?: ContentCreatorStore;
  open: boolean;
}

export interface IState {
  isLoadingTemplates: boolean;
}

@inject('contentCreatorStore')
@observer
export class EditPanel extends React.Component<IProps, IState> {
  private readonly localizationService = new LocalizationService();
  constructor(props: IProps) {
    super(props);
    this.state = {
      isLoadingTemplates: false,
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentWillReceiveProps(): void {
    if (this.props.contentCreatorStore.itemToEdit && this.props.contentCreatorStore.itemToEdit.component && !this.props.contentCreatorStore.availableInstancesForComponent) {
      this.loadInstances();
    }
  }

  private getSiteCollectionForComponent(): string {
    let siteCollection;
    switch (this.props.contentCreatorStore.itemToEdit.component) {
      case "Messages":
        siteCollection = "IntraActive-Messages"
        break;
      case "Event":
        siteCollection = "IntraActive-Events"
        break;
      case "ContentOrganizer":
        siteCollection = "IntraActive-ContentOrganizer"
        break;
      default:
        break;
    }
    return siteCollection;
  }

  private loadInstances(): void {
    this.props.contentCreatorStore.availableInstancesForComponent = undefined;
    this.props.contentCreatorStore.availableCategoriesForComponent = undefined;
    this.props.contentCreatorStore.loadingInstances = true;
    InstanceService.getInstances(this.props.contentCreatorStore.environment, this.props.contentCreatorStore.token, this.props.contentCreatorStore.tenant, this.getSiteCollectionForComponent(), true).then((instances: IInstance[]) => {
      this.props.contentCreatorStore.loadingInstances = false;
      const tempArray = [];
      instances.forEach((instance: IInstance) => {
        if (instance.instanceName == null) {
          instance.instanceName = "Default";
        }
        tempArray.push({
          "key": JSON.stringify({
            instanceName: instance.instanceName,
            id: instance?.id
          }),
          "value": instance.title
        });
      });
      const firstInstance = tempArray.length > 0 ? JSON.parse(tempArray[0].key) : undefined;
      this.props.contentCreatorStore.itemToEdit.instance = this.props.contentCreatorStore.itemToEdit.instance ? this.props.contentCreatorStore.itemToEdit.instance : firstInstance;
      this.props.contentCreatorStore.availableInstancesForComponent = tempArray;
      // this.loadCategories();
      this.loadTemplates();
    });
  }

  private childrenCategoriesAreChecked(category: any, id: string): void {
    if (category.children) {
      category.children.forEach((child: any) => {
        if (id === child.guid) {
          child.checked = true;
        }
        this.childrenCategoriesAreChecked(child, id);
      });
    }
  }

  // private loadCategories(): void {
  //   if (this.props.contentCreatorStore.itemToEdit.component === "Messages" || this.props.contentCreatorStore.itemToEdit.component === "Event") {
  //     this.props.contentCreatorStore.availableCategoriesForComponent = undefined;
  //     this.props.contentCreatorStore.loadingCategories = true;
  //     CategoryService.getCategories(this.props.contentCreatorStore.environment, this.props.contentCreatorStore.itemToEdit.instance.instanceName, this.props.contentCreatorStore.tenant, this.props.contentCreatorStore.token, this.getSiteCollectionForComponent(), this.props.contentCreatorStore.itemToEdit.component).then((result) => {
  //       this.props.contentCreatorStore.loadingCategories = false;
  //       if (result && result[0] && result[0].data) {
  //         if (this.props.contentCreatorStore.itemToEdit.categories && this.props.contentCreatorStore.itemToEdit.categories.length > 0) {
  //           this.props.contentCreatorStore.itemToEdit.categories.forEach((selectedCategory: ICategory) => {
  //             result[0].data.items.forEach((category: any) => {
  //               if (selectedCategory.id === category.guid) {
  //                 category.checked = true;
  //               }
  //               this.childrenCategoriesAreChecked(category, selectedCategory.id);
  //             });
  //           });
  //         }
  //         this.props.contentCreatorStore.availableCategoriesForComponent = result[0].data.items;
  //       }
  //     });
  //   }
  // }

  private loadTemplates(): void {
    const isMessages = this.props.contentCreatorStore.itemToEdit.component === "Messages";
    const isEvents = this.props.contentCreatorStore.itemToEdit.component === "Event";
    if ((isMessages || isEvents) && this.props.contentCreatorStore.itemToEdit?.instance?.instanceName) {
      this.setState({isLoadingTemplates: true}, () => {
        if (isMessages) {
          MessageTemplateService.getAllTemplates(this.props.contentCreatorStore.environment, this.props.contentCreatorStore.tenant, this.props.contentCreatorStore.itemToEdit.instance.instanceName).then(response => {
            this.props.contentCreatorStore.availableTemplatesForInstance = response.templates;
          }).finally(() => this.setState({isLoadingTemplates: false}));
        }
        if (isEvents) {
          EventTemplateService.getAllTemplates(this.props.contentCreatorStore.environment, this.props.contentCreatorStore.tenant, this.props.contentCreatorStore.itemToEdit.instance.instanceName).then(response => {
            this.props.contentCreatorStore.availableTemplatesForInstance = response.templates;
          }).finally(() => this.setState({isLoadingTemplates: false}));
        }
      });
    }
  }

  private getChoiceGroupOptions(): ChoiceOptions[] {
    let options: ChoiceOptions[] = [
      {
        key: "messages",
        text: this.localizationService.strings.Messages_AddMessage
      },
      {
        key: "newsLinks",
        text: this.localizationService.strings.Messages_AddNewsLink
      }
    ];

    if (this.props.contentCreatorStore.availableTemplatesForInstance?.length > 0) {
      this.props.contentCreatorStore.availableTemplatesForInstance.forEach(template => {
        options.push({
          key: template.id,
          text: template.title
        });
      });
    }

    return options;
  }

  private getChoicheGroupSkeleton(): JSX.Element {
    return <div
      style={{
        marginTop: 15,
        display: "flex",
        flexDirection: "column",
        float: "left",
        clear: "both",
        width: "100%"
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row"
        }}
      >
        <IASkeleton
          skeleton={{
            height: 18,
            width: 18,
            borderRadius: 10,
            marginRight: 10
          }}
        />
        <IASkeleton
          skeleton={{
            height: 18,
            width: "60%",
            borderRadius: 5,
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: 10
        }}
      >
        <IASkeleton
          skeleton={{
            height: 18,
            width: 18,
            borderRadius: 10,
            marginRight: 10
          }}
        />
        <IASkeleton
          skeleton={{
            height: 18,
            width: "40%",
            borderRadius: 5,
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: 10
        }}
      >
        <IASkeleton
          skeleton={{
            height: 18,
            width: 18,
            borderRadius: 10,
            marginRight: 10
          }}
        />
        <IASkeleton
          skeleton={{
            height: 18,
            width: "55%",
            borderRadius: 5,
          }}
        />
      </div>
    </div>;
  }

  public render(): JSX.Element {
    const content = (
      <div style={{
        padding: "0 40px"
      }}>
        <IATextField
          label={`${this.localizationService.strings.ContentCreatorAdmin_ItemTitle}*`}
          text={this.props.contentCreatorStore.itemToEdit ? this.props.contentCreatorStore.itemToEdit.title : undefined}
          onChange={(title: string) => {
            this.props.contentCreatorStore.itemToEdit.title = title;
            this.render();
          }}
          borderRadius={5}
          highlightColor={this.props.contentCreatorStore.highlightColor}
        />
        <IATextField
          label={this.localizationService.strings.ContentCreatorAdmin_ItemDescription}
          text={this.props.contentCreatorStore.itemToEdit ? this.props.contentCreatorStore.itemToEdit.description : undefined}
          onChange={(description: string) => {
            this.props.contentCreatorStore.itemToEdit.description = description;
          }}
          borderRadius={5}
          highlightColor={this.props.contentCreatorStore.highlightColor}
        />
        <IAIconPicker
          label={`${this.localizationService.strings.ContentCreatorAdmin_SelectIcon}*`}
          selectedIcon={this.props.contentCreatorStore.itemToEdit ? this.props.contentCreatorStore.itemToEdit.icon : undefined}
          color={this.props.contentCreatorStore.highlightColor}
          select={(icon: string) => this.props.contentCreatorStore.itemToEdit.icon = icon}
          shouldBeAbleToClear={false}
          clear={() => { }}
        />
        <IAOptionSelector
          label={`${this.localizationService.strings.ContentCreatorAdmin_SelectComponent}*`}
          options={
            [
              {
                icon: "Comment",
                key: "Messages",
                text: this.localizationService.strings.ContentCreatorAdmin_MessagesComponent
              },
              {
                icon: "Calendar",
                key: "Event",
                text: this.localizationService.strings.ContentCreatorAdmin_EventComponent
              },
              {
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Map/SVG/ic_fluent_map_24_regular.svg",
                key: "ContentOrganizer",
                text: this.localizationService.strings.ContentCreatorAdmin_ContentOrganizerComponent
              }
            ]
          }
          selected={this.props.contentCreatorStore.itemToEdit && this.props.contentCreatorStore.itemToEdit.component}
          highlightColor={this.props.contentCreatorStore.highlightColor}
          onChange={(option: string) => {
            this.props.contentCreatorStore.itemToEdit.component = option as "Messages" | "Event" | "ContentOrganizer";
            this.loadInstances();
          }}
          borderRadius={5}
        />
        {this.props.contentCreatorStore.loadingInstances ?
          <div style={{
            marginTop: 20,
            clear: "both",
            position: "relative",
            float: "left",
            color: "#999999"
          }}>
            {this.localizationService.strings.ContentCreatorAdmin_LoadingInstances}
          </div>
        :
          <>
            {this.props.contentCreatorStore.availableInstancesForComponent &&
            <>
              <div style={{
                marginTop: 0,
                clear: "both",
                position: "relative",
                float: "left"
              }}
              >
                <IADropDown
                  label={`${this.localizationService.strings.ContentCreatorAdmin_SelectInstance}*`}
                  selectedOption={this.props.contentCreatorStore.itemToEdit ? JSON.stringify(this.props.contentCreatorStore.itemToEdit.instance) : undefined}
                  options={this.props.contentCreatorStore.availableInstancesForComponent}
                  onChange={(instance: string) => {
                    if (instance) {
                      this.props.contentCreatorStore.itemToEdit.instance = JSON.parse(instance);
                      this.props.contentCreatorStore.itemToEdit.messageType = "messages";
                      this.props.contentCreatorStore.itemToEdit.templateId = "";
                      // this.loadCategories();
                      this.loadTemplates();
                    }
                  }}
                  highlightColor={this.props.contentCreatorStore.highlightColor}
                  borderRadius={5}
                />
              </div>
              {(this.props.contentCreatorStore.itemToEdit?.component === "Messages" || this.props.contentCreatorStore.itemToEdit?.component === "Event") &&
                <>
                  {this.state.isLoadingTemplates ? 
                    this.getChoicheGroupSkeleton()
                  :
                    <div style={{
                      marginTop: 10,
                      marginBottom: 20,
                      clear: "both",
                      position: "relative",
                      float: "left"
                    }}
                    >
                      <IAChoiceGroup
                        highlightColor={this.props.contentCreatorStore.highlightColor}
                        onChange={(key) => {
                          if (key === "messages" || key === "newsLinks") {
                            this.props.contentCreatorStore.itemToEdit.messageType = key;
                            this.props.contentCreatorStore.itemToEdit.templateId = "";
                          } else {
                            // template selected
                            this.props.contentCreatorStore.itemToEdit.messageType = "messages";
                            this.props.contentCreatorStore.itemToEdit.templateId = key;
                          }
                        }}
                        selectedKey={this.props.contentCreatorStore.itemToEdit?.templateId ?? this.props.contentCreatorStore.itemToEdit?.messageType ?? "messages"}
                        required={false}
                        options={this.getChoiceGroupOptions()}
                      />
                    </div>
                  }
                </>
              }
            </>
            }
          </>
        }
        {/* {this.props.contentCreatorStore.loadingCategories &&
          <div style={{
            marginTop: 20,
            clear: "both",
            position: "relative",
            float: "left",
            color: "#999999",
          }}>
            {this.localizationService.strings.ContentCreatorAdmin_LoadingCategories}
          </div>
        }
        {this.props.contentCreatorStore.availableCategoriesForComponent && !this.props.contentCreatorStore.loadingCategories &&
          <div style={{
            marginTop: 20,
            clear: "both",
            position: "relative",
            float: "left"
          }}
          >
            <IATreeview
              label={this.localizationService.strings.ContentCreatorAdmin_SelectCategories}
              highlightColor={this.props.contentCreatorStore.highlightColor}
              actionType="Checkbox"
              expanded={false}
              structureType="Arrow"
              onChange={(items: ITreeViewItem[]) => {
                this.props.contentCreatorStore.itemToEdit.categories = [];
                items.forEach((item: ITreeViewItem) => {
                  this.hasSelectedChild(item);
                  if (item.checked) {
                    this.props.contentCreatorStore.itemToEdit.categories.push(
                      {
                        id: item.guid,
                        name: item.name
                      }
                    );
                  }
                });
              }}
              items={this.props.contentCreatorStore.availableCategoriesForComponent}
              useColors
              style={{
                marginBottom: 30
              }}
            />
          </div>
        }
        {(this.props.contentCreatorStore.itemToEdit?.component === "Messages" || this.props.contentCreatorStore.itemToEdit?.component === "Event") &&
          !this.props.contentCreatorStore.availableCategoriesForComponent && !this.props.contentCreatorStore.loadingCategories &&
          <div style={{
            marginTop: 20,
            clear: "both",
            position: "relative",
            float: "left",
            color: "#999999",
          }}>
            {this.localizationService.strings.Categories_NoCategories}
          </div>
        } */}
      </div>
    )
    const disableSaving = !(this.props.contentCreatorStore.itemToEdit &&
      this.props.contentCreatorStore.itemToEdit.title &&
      this.props.contentCreatorStore.itemToEdit.title !== "" &&
      this.props.contentCreatorStore.itemToEdit.component &&
      this.props.contentCreatorStore.itemToEdit.instance);
    return (
      <IAPanel
        showNavigationBar={true}
        title={this.props.contentCreatorStore.isCreatingNewItem ? this.localizationService.strings.ContentCreatorAdmin_NewItem : this.localizationService.strings.ContentCreatorAdmin_EditItem}
        component={"ContentCreator"}
        open={!!this.props.contentCreatorStore.itemToEdit}
        transition="slide"
        width={this.props.contentCreatorStore.isMobile ? window.innerWidth : 600}
        isMobile={false}
        highlightColor={this.props.contentCreatorStore.highlightColor}
        marginTop={this.props.contentCreatorStore.marginTop}
        disableSaving={disableSaving || this.props.contentCreatorStore.isSaving}
        close={() => {
          if (this.props.contentCreatorStore.itemToEdit && this.props.contentCreatorStore.itemToEdit.title != undefined && this.props.contentCreatorStore.itemToEdit.title != "") {
            this.props.contentCreatorStore.showCancelEditPopup = true;
          } else {
            this.close();
          }
        }}
        onSaveAndClose={() => {
          this.save().then(() => {
            this.close();
          });
        }}
        onDelete={(this.props.contentCreatorStore.itemToEdit && !this.props.contentCreatorStore.isCreatingNewItem) ? () => {
          this.props.contentCreatorStore.delete();
          this.props.contentCreatorStore.isSaving = true;
          const contentCreator: IContentCreator = {
            id: this.props.contentCreatorStore.id,
            title: this.props.contentCreatorStore.title,
            config: this.props.contentCreatorStore.items
          }
          ContentCreatorService.update(this.props.contentCreatorStore.environment, this.props.contentCreatorStore.token, this.props.contentCreatorStore.tenant, this.props.contentCreatorStore.instance.instanceName, contentCreator).then((id: number) => {
            this.props.contentCreatorStore.isSaving = false;
            this.props.contentCreatorStore.itemToEdit = undefined;
            this.props.contentCreatorStore.id = id;
          });
        } : undefined}
      >{content}</IAPanel>
    );
  }

  private hasSelectedChild(item: ITreeViewItem): void {
    item.children?.forEach((child: ITreeViewItem) => {
      if (child.checked) {
        this.props.contentCreatorStore.itemToEdit.categories.push(
          {
            id: child.guid,
            name: child.name
          }
        );
      };
      this.hasSelectedChild(child);
    });
  }

  private close(): void {
    this.props.contentCreatorStore.itemToEdit = undefined;
    this.props.contentCreatorStore.isCreatingNewItem = false;
    this.props.contentCreatorStore.availableInstancesForComponent = undefined;
    this.props.contentCreatorStore.availableCategoriesForComponent = undefined;
  }

  private save(): Promise<void> {
    return new Promise<void>((resolve: () => void): void => {
      this.props.contentCreatorStore.isSaving = true;
      if (this.props.contentCreatorStore.isCreatingNewItem) {
        this.props.contentCreatorStore.items.push(this.props.contentCreatorStore.itemToEdit);
      }
      const contentCreator: IContentCreator = {
        id: this.props.contentCreatorStore.id,
        title: this.props.contentCreatorStore.title,
        config: this.props.contentCreatorStore.items
      }
      ContentCreatorService.update(this.props.contentCreatorStore.environment, this.props.contentCreatorStore.token, this.props.contentCreatorStore.tenant, this.props.contentCreatorStore.instance.instanceName, contentCreator).then((id: number) => {
        this.props.contentCreatorStore.isSaving = false;
        this.props.contentCreatorStore.id = id;
        resolve();
      });
    });
  }

  
}